// The observed width of the FormFieldDate input component. If we make styling changes to this component that affect its
// width, we should update this value to reflect the new observed width.
// eslint-disable-next-line import/prefer-default-export
export const FORM_FIELD_DATE_WIDTH = 170;

export const SCREEN_WIDTH_THRESHOLD = {
    SMALL: 390,
    MEDIUM: 650,
    LARGE: 1000
  };